import { render, staticRenderFns } from "./ModalAddProcedures.vue?vue&type=template&id=213d0e88&"
import script from "./ModalAddProcedures.vue?vue&type=script&lang=js&"
export * from "./ModalAddProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports